var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGames(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-8fc42042": "",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.75,
    d: "M14.12 5.102a5.458 5.458 0 0 0-7.726 0L5.1 6.398c-2.135 2.122-2.135 5.584 0 7.72l8.766 8.78h.014a5.458 5.458 0 0 0 7.725 0l1.293-1.296c2.135-2.122 2.135-5.584 0-7.72l-4.39-4.39-1.325-1.325"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.8 16.358-.354-.34a.936.936 0 0 1 0-1.37 1.032 1.032 0 0 1 1.43 0l.353.34a.936.936 0 0 1 0 1.37 1.032 1.032 0 0 1-1.43 0Zm-.03 4.757-.354-.338a.936.936 0 0 1 0-1.37 1.032 1.032 0 0 1 1.429 0l.354.338a.936.936 0 0 1 0 1.37 1.032 1.032 0 0 1-1.43 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.569 10.094a.875.875 0 0 0-1.238-1.238l-.619.619-.618-.619a.875.875 0 1 0-1.238 1.238l.619.618-.619.619a.875.875 0 0 0 1.238 1.238l.618-.62.619.62a.875.875 0 0 0 1.238-1.238l-.62-.619.62-.618Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.c6142361d12a1aeb8cf847bbe9f5e188.svg";
export { ForwardRef as ReactComponent };